export const blockIconsPhotoandimageFlashOnNew = (
	<span className='material-symbols-outlined'>flash_on</span>
);
